'use client';

import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import { ThemeProvider } from '@mui/material/styles';
import { ButtonOnLight } from 'ui/buttons';
import theme from 'ui/theme';
import { replaceUrls } from 'utils/urls';
import Link from 'next/link';
import { COOKIE_PRIVACY, COOKIE_CONSENT_ENABLED } from 'ui/constants/constants';
import { getCookie } from 'cookies-next';
import LOCATION_PATHS from '@lingo/adobe-analytics';

function StickyCTA({ environment }) {
  const [isVisible, setIsVisible] = useState(false);
  const [stickyBtnUrl, setStickyBtnUrl] = useState('');
  const [areCookiesEnabled, setAreCookiesEnabled] = useState(true);
  const cookieConsent = getCookie(COOKIE_PRIVACY);
  const areConsentCookiesOn = cookieConsent ? cookieConsent.startsWith(COOKIE_CONSENT_ENABLED) : true;
  const useCookieOffStyles = !areCookiesEnabled || !areConsentCookiesOn || false;

  useEffect(() => {
    setAreCookiesEnabled(navigator.cookieEnabled);
  }, []);

  useEffect(() => {
    const url = replaceUrls('https://shop.hellolingo.com/', environment);
    setStickyBtnUrl(url);
  }, [environment]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset >= 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {isVisible && (
        <Box
          position='sticky'
          bottom='0'
          display={{ xs: 'flex', md: 'none' }}
          backgroundColor='colorTheme.backgroundPrimaryLightWeb'
          height={useCookieOffStyles ? '122px' : '96px'}
          alignItems='center'
          data-testid='sticky-cta'
          zIndex='10'
          gridColumn='1/-1'
          data-analytics-location={LOCATION_PATHS.stickyCTA}
        >
          <Zoom in={isVisible} style={{ transitionDelay: isVisible ? '70ms' : '0ms' }}>
            <Link
              href={stickyBtnUrl}
              style={{
                width: '100%',
                marginLeft: useCookieOffStyles ? '20px' : '0',
                marginRight: useCookieOffStyles ? '20px' : '0',
              }}
              data-analytics-location={LOCATION_PATHS.stickyCTA}
              data-analytics-action='Buy Lingo'
            >
              <ButtonOnLight
                sx={{
                  height: '64px',
                  width: useCookieOffStyles ? '100%' : '70%',
                  marginLeft: useCookieOffStyles ? '0' : '16px',
                }}
              >
                <Typography variant='buttonL'>Buy Lingo</Typography>
              </ButtonOnLight>
            </Link>
          </Zoom>
        </Box>
      )}
    </ThemeProvider>
  );
}

export default StickyCTA;
